import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {
  fetchDepartment,
  fetchDepartmentList,
} from './../actions/DepartmentActions';

const DepartmentSlice = createSlice({
  name: 'department',
  initialState: {
    departmentSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    departmentList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartment.pending, (state) => {
        state.departmentSelection.status = 'loading';
      })
      .addCase(fetchDepartment.fulfilled, (state, action) => {
        state.departmentSelection.status = 'idle';
        state.departmentSelection.data = action.payload.result;
      })
      .addCase(fetchDepartment.rejected, (state, action) => {
        state.departmentSelection.status = 'rejected';
        state.departmentSelection.error = action.error.message;
      })

      .addCase(fetchDepartmentList.pending, (state) => {
        state.departmentList.status = 'loading';
      })
      .addCase(fetchDepartmentList.fulfilled, (state, action) => {
        state.departmentList.status = 'idle';
        state.departmentList.data = action.payload.result;
      })
      .addCase(fetchDepartmentList.rejected, (state, action) => {
        state.departmentList.status = 'rejected';
        state.departmentList.error = action.error.message;
      });
  },
});

export default DepartmentSlice.reducer;
